/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type MembershipStatus = 0 | 1 | 2 | 3 | 4;

export const MembershipStatus = {
    NUMBER_0: 0 as MembershipStatus,
    NUMBER_1: 1 as MembershipStatus,
    NUMBER_2: 2 as MembershipStatus,
    NUMBER_3: 3 as MembershipStatus,
    NUMBER_4: 4 as MembershipStatus
}